<!--
  A view that lays GDPR confirmation request
-->
<template>
  <div>
    <div class="data_protection__form">

      <!-- Checkbox field -->
      <div class="data_protection__field">
        <app-checkbox
          class="data_protection__checkbox"
          :uncheckedSrc="'/static/theme/img/checkbox-unchecked.png'"
          :checkedSrc="'/static/theme/img/checkbox-checked.png'"
          :selected.sync="selected"
          @change="onMsCheckboxChange" />

        <span>
          {{ privacyPolicy.checkboxText }}
          <p
            @click="openPrivacyPolicy"
            class="data_protection__link">
            {{ privacyPolicy.buttonText }}
          </p>
        </span>
      </div>

      <!-- Button -->
      <AppButton
        @click.native="onButtonClick"
        class="data_protection__button"
        :state="buttonState"
        :type="buttonType"
        :text="$t(nextButtonText)"
        :hasIconRight="true" />
    </div>

    <!-- App message to contain Privacy policy -->
    <ms-app-message
      :title="privacyPolicy.privacyPolicyTitle"
      :isOpen.sync="showPrivacyPolicy">
      <span v-for="section in privacyPolicy.policySections">
        <h2 v-if="section.heading">{{ section.heading }}</h2>
        <p
          v-for="paragraph in section.content"
          v-html="paragraph"/>
      </span>
    </ms-app-message>

  </div>
</template>

<script>
  import api from '@/api/api'
  import {ButtonStates, ButtonTypes} from '@/components/app-button'
  import MsAppMessage from '@/components/ms-app-message'
  import themeSettings from '@/theme-settings.json'

  export default {
    name: 'DataProtectionView',
    components: {
      MsAppMessage
    },

    data: function () {
      return {
        privacyPolicy: {},
        showPrivacyPolicy: false,
        nextButtonText: 'message.gdpr.nextButtonText',
        selected: false,
        claimTypeSelectionEnabled: !!themeSettings.theme.claimTypeSelectionEnabled
      }
    },
    mounted () {
      /**
       * Get privacy policy data from api
       */
      api.getPrivacyPolicy()
        .then(response => {
          this.privacyPolicy = response.data
        })
        .catch(console.error)
      this.selected = this.dataProtectionConsent
    },
    watch: {
      selected: function () {
        // console.log('data protection selected changed: ' + this.selected)
      }
    },
    methods: {
      /**
       * Move to next step of the app
       */
      onButtonClick: function () {
        if (this.dataProtectionConsent) {
          if (this.claimTypeSelectionEnabled) {
            this.$router.push('/claim-type')
          } else {
            // assume one claim type
            this.$store.commit('setClaimType', 2)
            this.$router.push('/flight-details')
          }
        }
      },

      /**
       * Open privacy policy
       */
      openPrivacyPolicy: function () {
        this.showPrivacyPolicy = true
      },

      /**
       * Change checked to change value
       *
       * @param {boolean} isChecked - Whether checkbox is checked
       */
      onMsCheckboxChange: function (isChecked) {
        this.dataProtectionConsent = isChecked
      }
    },

    computed: {
      dataProtectionConsent: {
        /**
         * Gets current stored data protection consent
         */
        get () {
          return this.$store.getters.dataProtectionConsent
        },

        /**
         * Sets data protection consent value
         *
         * @param {boolean} value - Whether consent has been given
         */
        set (value) {
          this.$store.commit('setDataProtectionConsent', value)
        }
      },

      /**
       * Gets button state
       */
      buttonState: {
        get () {
          return this.dataProtectionConsent ? ButtonStates.ENABLED : ButtonStates.DISABLED
        }
      },

      /**
       * Gets the button type
       */
      buttonType: {
        get () {
          return ButtonTypes.PRIMARY
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../assets/sass/main.scss";
  @import "data-protection.scss";
</style>
